import { css } from 'emotion';

export const container = css`
  margin: 10px 0 20px;
`;

export const header = css`
  margin: 0 20px 20px;

  > :not(:first-child) {
    margin-top: 40px;
  }
`;

export const table = css`
  overflow-y: auto;
  max-height: calc((75vh - 130px) - 100px);
`;

export const checkboxColumn = css`
  && {
    width: 40px;
    padding-left: 20px;
    padding-right: 0;
  }
`;

const placeholder = css`
  content: "";
  border: none;
  margin: 30px 0 0;
`;

export const placeholderWithoutTextButton = css`
  ${placeholder} margin-bottom: 30px;
`;

export const loading = css`
  margin: 60px auto;
  width: 100%;
`;
